<template>
  <div>
    <b-container fluid class="px-5">

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="species ? species.name : ''"/>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="bold-text main-color">
          Famille
        </div>
        <div class="mt-2" v-if="species">
          {{ species.family.name }}
        </div>
        <div class="mt-4  bold-text main-color">
          Nom
        </div>
        <div class="mt-2" v-if="species">
          {{ species.name }}
        </div>
        <div class="mt-4  bold-text main-color">
          Aliments
        </div>
        <div class="mt-2">
          <ul v-if="foodSpeciess && foodSpeciess.length > 0">
            <li v-for="foodSpecies in foodSpeciess" :key="foodSpecies.id">
              <b-link :to="{ name: 'FoodShow', params: { foodId: foodSpecies.food.id.toString() }}">
                {{foodSpecies.food.name}}
              </b-link>
            </li>
          </ul>
          <span v-else>N/A</span>
        </div>
      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <species-delete-modal :selectedSpecies="ui.selectedSpecies" @didDeleteSpecies="didDeleteSpecies()"></species-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import ShowActions from "../../components/ShowActions";
import SpeciesDeleteModal from "./SpeciesDeleteModal";

export default {

  name: 'SpeciesShow',

  components: {
    BackArrow,
    ShowActions,
    SpeciesDeleteModal
  },

  data() {
    return {

      speciesId: this.$route.params.speciesId,
      species: null,
      foodSpeciess: [],

      ui: {
        selectedSpecies: null
      }
    }
  },

  created () {
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchSpecies()
      this.fetchFoodSpecies()
    },

    fetchSpecies() {
      api
        .get(`/species/${this.speciesId}`)
        .then(response => {
          this.species = response.data
        })
    },

    fetchFoodSpecies() {
      api
        .get(`/foodSpecies?speciesId=${this.speciesId}`)
        .then(response => {
          this.foodSpeciess = response.data.filter(item => item)
        })
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'SpeciesEdit',
        params: {
          speciesId: this.speciesId
        }
      })
    },

    clickOnDeleteBtn() {
      this.ui.selectedSpecies = this.species
      this.$bvModal.show('species-delete-modal')
    },

    didDeleteSpecies() {
      this.ui.selectedCategory = null;
      this.$router.push({
        name: 'SpeciesIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(`Species \"${this.species.name}\" supprimé`)
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/species/SpeciesShow.vue